export default function StickyNav() {
    return {
        mounted() {
            const nav = this.$el;
            window.addEventListener('scroll', () => {
                if (window.scrollY > 50) {
                    nav.classList.add('shadow-md', 'bg-tan/95');
                    nav.classList.remove('bg-tan/0');
                } else {
                    nav.classList.remove('shadow-md', 'bg-tan/95');
                    nav.classList.add('bg-tan/0');
                }
            });
        }
    }
}
